import type { TaxCode } from "@/apis/gql/types";
import type { ButtonProps } from "../../ui/button";
import { ComboBox, type ComboOption } from "../tables/tableComboBox";

export type Props = {
  currentOption?: ComboOption;
  onChange: (value: ComboOption["value"]) => void;
  onFocus?: () => void;
  items: TaxCode[];
  variant?: string;

  placeholder?: string;
  emptyLabel?: string;
  className?: ButtonProps["className"];
  disabled?: boolean;
  fullWidth?: boolean;
  side?: "top" | "bottom";
  sideOffset?: number;
  container?: React.RefObject<HTMLElement>;
  readOnly?: boolean;
  modal?: boolean;
};

export const BuDropdown = ({
  currentOption,
  onChange,
  onFocus,
  items,
  variant,
  placeholder = "BU",
  className,
  disabled,
  fullWidth,
  sideOffset,
  container,
  side,
  readOnly,
  modal = false,
}: Props) => {
  const taxCodeOptions = items.map(
    (taxCode): ComboOption => ({
      label: taxCode.name,
      alternativeLabels: [taxCode.datevBu],
      value: taxCode.taxCodeId,
      subLabel: taxCode.datevBu,
    }),
  );

  return (
    <ComboBox
      readOnly={readOnly}
      disabled={disabled}
      currentOption={currentOption}
      onChange={onChange}
      items={taxCodeOptions ?? []}
      placeholder={placeholder}
      emptyLabel={null}
      variant={variant}
      className={className}
      popoverAlignStart
      fullWidth={fullWidth}
      onFocus={onFocus}
      sideOffset={sideOffset}
      side={side}
      container={container}
      modal={modal}
    />
  );
};
